import { Card, Container, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
// sections
import SendPushNotificationForm from '../sections/form/SendPushNotificationForm';
// hooks
import useResponsive from '../hooks/useResponsive';

// components
import Page from '../components/Page';

export default function SendPushNotification() {
  const { t } = useTranslation();
  // const theme = useTheme();
  // const smUp = useResponsive('up', 'sm');
  const mdUp = useResponsive('up', 'md');

  return (
    <Page title={t('notify.send_title')}>
      <Container maxWidth={false}>
        <Typography variant="h4" sx={{ mb: 5 }}>
          {t('notify.send_title')}
        </Typography>
        <Card>
          <SendPushNotificationForm />
        </Card>

        {/* <RootStyle>
          {mdUp && (
            <SectionStyle>
              <img src="/static/illustrations/illustration_register.png" alt="create admin" />
            </SectionStyle>
          )}

          <ContentStyle>
            <Typography variant="h6" sx={{ mt: 1, mb: 4 }}>
              Please fill in the basic info
            </Typography>
            <SendPushNotificationForm />
          </ContentStyle>
        </RootStyle> */}
      </Container>
    </Page>
  );
}
